/*
 * Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import _replace from "lodash/replace";
import _findKey from "lodash/findKey";
import { getCaseLink, getProductData } from "./productService";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";

class RedirectService {
  getApplicationStep = (applicationStatus: number, product: AbstractCase) => {
    const applicationStatusSummary = getProductData(product.name, "summaryStatus");
    const formSteps = getProductData(product.name, "formSteps");
    const targetApplicationStatus = product.applicationStatus > applicationStatusSummary || !applicationStatus ? product.applicationStatus : applicationStatus;
    return getCaseLink(product) + "/antrag/" + formSteps[targetApplicationStatus].stepUrl;
  };

  getStatusByLocation = (location: string, product: AbstractCase) => {
    const formSteps = getProductData(product.name, "formSteps");
    const stepUrl = _replace(location, getCaseLink(product) + "/antrag/", "");
    const formStepKey = _findKey(formSteps, ["stepUrl", stepUrl]);
    if (!formStepKey) {
      return null;
    }
    return parseInt(formStepKey, 10);
  };

  getApplicationLocation = (product: AbstractCase, pathname: string) => {
    return this.getApplicationStep(this.getStatusByLocation(pathname, product) || product.applicationStatus, product);
  };
}

export default new RedirectService();
